"use client";

import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { CategoriesQuery } from "@/types/generated";
import Link from "next/link";
import { JSX, useState } from "react";
import NewsletterSignup from "./newsletter";

type MainSidebarProps = {
  categories: CategoriesQuery["categories"];
};
export function MainSidebar({ categories }: MainSidebarProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const renderCategories = () => {
    const re: JSX.Element[] = [];

    for (const category of categories) {
      if (category) {
        re.push(
          <Link
            href="/topic/[slug]"
            as={`/topic/${category.slug}`}
            key={category.documentId}
            onClick={() => setIsSidebarOpen(false)}
            className="flex items-center justify-between text-lg font-semibold hover:bg-neutral-900 px-4 py-2 cursor-pointer"
          >
            <div className="flex items-center justify-center gap-2">
              {/* <span className="icon-[tabler--arrow-badge-right-filled] tex-xl"></span> */}
              {category.name}
            </div>
            <div className="flex items-center justify-center">
              {/* <span className="icon-[tabler--chevron-right] text-2xl"></span> */}
              {/* <span className="icon-[tabler--arrow-badge-right-filled] tex-xl"></span> */}
              {/* ({category.articleCount}) */}
            </div>
          </Link>
        );
      }
    }
    return re;
  };

  return (
    <div className="">
      {/* only for server side rendering - do not remove*/}
      <div className="hidden">{renderCategories()}</div>

      {/* for client side - only visible at client side */}
      <Sheet key={"left"} onOpenChange={setIsSidebarOpen} open={isSidebarOpen}>
        <SheetTrigger asChild>
          <Button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            variant={"ghost"}
            size="icon"
            className="rounded-full hover:bg-neutral-700 hover:text-white cursor-pointer"
            aria-label="Open navigation menu"
          >
            <span className="icon-[tabler--menu-2] text-2xl"></span>
          </Button>
        </SheetTrigger>
        <SheetContent
          side={"left"}
          className="gap-0 z-[10000] bg-neutral-950 border-r border-neutral-900 text-neutral-50"
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <NewsletterSignup />
          <div className="flex flex-col gap-0 overflow-y-auto pb-4">
            {renderCategories()}
            <Link
              href="/fact"
              as={`/fact`}
              onClick={() => setIsSidebarOpen(false)}
              className="flex items-center justify-between text-lg font-semibold hover:bg-neutral-900 px-4 py-2 cursor-pointer"
            >
              <div className="flex items-center justify-center gap-2">
                Today&apos;s Fact
              </div>
              <div className="flex items-center justify-center">
                {/* <span className="icon-[tabler--arrow-badge-right-filled] tex-xl"></span> */}
              </div>
            </Link>
            <Link
              href="/tools"
              as={`/tools`}
              onClick={() => setIsSidebarOpen(false)}
              className="flex items-center justify-between text-lg font-semibold hover:bg-neutral-900 px-4 py-2 cursor-pointer"
            >
              <div className="flex items-center justify-center gap-2">
                Tools
              </div>
              <div className="flex items-center justify-center">
                {/* <span className="icon-[tabler--arrow-badge-right-filled] tex-xl"></span> */}
              </div>
            </Link>
            <Link
              href="/financial-calendar"
              as={`/financial-calendar`}
              onClick={() => setIsSidebarOpen(false)}
              className="flex items-center justify-between text-lg font-semibold hover:bg-neutral-900 px-4 py-2 cursor-pointer"
            >
              <div className="flex items-center justify-center gap-2">
                Financial Calendar
              </div>
              <div className="flex items-center justify-center">
                {/* <span className="icon-[tabler--arrow-badge-right-filled] tex-xl"></span> */}
              </div>
            </Link>
          </div>
          {/* <SheetFooter>
            <SheetClose asChild>
              <Button type="submit">Browse All Categories</Button>
            </SheetClose>
          </SheetFooter> */}
        </SheetContent>
      </Sheet>
    </div>
  );
}
